// extracted by mini-css-extract-plugin
module.exports = {"SliderMarkers-container":"SliderMarkerComponent_SliderMarkers-container__1Q6oC","SliderMarkers-marker":"SliderMarkerComponent_SliderMarkers-marker__29Zlj"};